export default __webpack_public_path__ + "static/media/people_type_five.5e2e19f2.svg";